import { render, staticRenderFns } from "./ModifierPriceAddEdit.vue?vue&type=template&id=0ea9f38c"
import script from "./ModifierPriceAddEdit.vue?vue&type=script&lang=js"
export * from "./ModifierPriceAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports